<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
  <form @submit.prevent="handleFormSubmit">
    <div class="form-row">
      <div class="form-group col-md-3 mb-2">
        <ValidationProvider name="PTA" rules="required" v-slot="{ errors }">
        <label class="form-label">PTA <span class="text-danger">*</span></label>
        <multi-select
            disabled
            :options="[payload.idPta]"
            placeholder="Sélectionnez une activité PTA"
            label="description"
            track-by="id"
            :searchable="false"
            v-model="payload.idPta"
            :custom-label="o => o.description"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            <strong> {{ option.description }}</strong>
          </template>
          <span slot="noOptions"><strong>Liste Vide</strong></span>
          <span slot="noResult"><strong>Aucun Résultat</strong></span>
        </multi-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group col-md-3 mb-2">
        <label class="form-label">Année PTA</label>
        <input type="text" class="form-control"  :value="payload.idPta?.annee?.annee" placeholder="Année PTA" />
      </div>

      <div class="form-group col-md-6 mb-2">
        <ValidationProvider name="Description" rules="required" v-slot="{ errors }">
          <label for="description" class="form-label">Description <span class="text-danger">*</span></label>
        <textarea id="description" class="form-control" v-model="payload.description" placeholder="Description" rows="3"></textarea>
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>


    </div>

    <div class="form-row">

        <div class="form-group col-md-4 mb-2">
          <ValidationProvider name="Type de livrable" rules="required" v-slot="{ errors }">
            <label class="form-label">Type de livrable <span class="text-danger">*</span></label>
            <multi-select
                :options="typeLivrables"
                placeholder="Sélectionnez un type de livrable"
                label="libTypeLivrable"
                track-by="id"
                :searchable="true"
                v-model="payload.idTypeLivrable"
                :custom-label="o => o.libTypeLivrable"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <strong> {{ option.libTypeLivrable }}</strong>
              </template>
              <span slot="noOptions"><strong>Liste Vide</strong></span>
              <span slot="noResult"><strong>Aucun Résultat</strong></span>
            </multi-select>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Phase concernée" rules="required" v-slot="{ errors }">
          <label class="form-label">Phase concernée <span class="text-danger">*</span></label>
        <GenericSelect
            v-model="payload.phaseConcernee"
            :options="phaseExecutions"
            label-key="nomPhase"
            track-key="idPhase"
            placeholder="Sélectionnez une phase"
        />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Priorité" rules="required" v-slot="{ errors }">
          <label class="form-label">Priorité <span class="text-danger">*</span></label>
        <GenericSelect
            v-model="payload.priorite"
            :options="allPriorities"
            label-key="libelle"
            track-key="priorite"
            placeholder="Sélectionnez une priorité"
        />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

    </div>

    <div class="form-row">
      <div class="form-group col-md-4 mb-2">
<!--        <ValidationProvider name="Entité en charge" rules="required" v-slot="{ errors }">-->
          <label class="form-label">Entité en charge <span class="text-danger">*</span></label>
        <GenericSelect
            v-model="payload.entiteCharge"
            :options="entiteTraitements"
            label-key="nomEntite"
            track-key="idEntite"
            placeholder="Sélectionnez une Entité en charge"
        />
<!--          <small class="text-danger">{{ errors[0] }}</small>-->
<!--        </ValidationProvider>-->
      </div>
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Référent PMO" rules="required" v-slot="{ errors }">
          <label class="form-label">Référent PMO <span class="text-danger">*</span></label>
        <GenericSelect
            v-model="payload.referentPmo"
            :options="contacts"
            label-key="nom"
            track-key="idContact"
            placeholder="Sélectionnez un Référent PMO"
        />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Point Focal ASIN" rules="required" v-slot="{ errors }">
          <label class="form-label">Point Focal ASIN <span class="text-danger">*</span></label>
        <GenericSelect
            v-model="payload.pointFocalAsin"
            :options="contacts"
            label-key="nom"
            track-key="idContact"
            placeholder="Sélectionnez le Point Focal ASIN"
        />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

    </div>

    <div class="form-row">
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Pôle" rules="required" v-slot="{ errors }">
        <label class="form-label">Pôle</label>
        <GenericSelect
            v-model="payload.pole"
            :options="allPoles"
            label-key="nomPole"
            track-key="idPole"
            placeholder="Sélectionnez le Pôle"
        />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Lot" rules="required" v-slot="{ errors }">
          <label class="form-label">Lot <span class="text-danger">*</span></label>
        <input type="text" class="form-control" v-model="payload.lot" placeholder="Lot" />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Statut" rules="required" v-slot="{ errors }">
        <label class="form-label">Statut</label>
        <GenericSelect
            v-model="payload.statut"
            :options="allStatus"
            label-key="libelle"
            track-key="valeur"
            placeholder="Sélectionnez le Statut"
        />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

    </div>

    <div class="form-row">
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="ASIN Lead" rules="required" v-slot="{ errors }">
        <label class="form-label">ASIN Lead</label>
        <input type="text" class="form-control" v-model="payload.asinLead" placeholder="ASIN Lead" />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="% Réalisation" rules="required" v-slot="{ errors }">
        <label class="form-label">% Réalisation</label>
        <input type="number" step="0.01" class="form-control" v-model="payload.pctRealisation" placeholder="% Réalisation" />
        <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Retard" rules="required" v-slot="{ errors }">
        <label class="form-label">Retard</label>
        <input type="text" class="form-control" v-model="payload.retard" placeholder="Retard" />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

    </div>

    <div class="form-row">

      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Revue PMO" rules="required" v-slot="{ errors }">
        <label class="form-label">Revue PMO</label>
        <input type="text" class="form-control" v-model="payload.revuePmo" placeholder="Revue PMO" />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Date prévue revue PMO" rules="required|date_format_yyyy_mm_dd" v-slot="{ errors }">
        <label class="form-label">Date prévue revue PMO</label>
        <input type="date" class="form-control" v-model="payload.datePrevueRevuePmo" />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div class="form-group col-md-4 mb-2">
        <ValidationProvider name="Date prévue revue DG" rules="required|date_format_yyyy_mm_dd" v-slot="{ errors }">
        <label class="form-label">Date prévue revue DG</label>
        <input type="date" class="form-control" v-model="payload.datePrevueRevueDg" />
          <small class="text-danger">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>


    <div class="form-group text-end mt-3">
      <button class="btn btn-gray me-2" type="button" @click="$emit('cancel')">Annuler</button>
      <button class="btn btn-success" type="submit" :disabled="invalid">
        <span class="fe" :class="isEditing ? 'fe-edit' : 'fe-check'"></span>
        {{ isEditing ? 'Modifier' : 'Enregistrer' }}
      </button>
    </div>
  </form>
  </ValidationObserver>
</template>

<script>
  import GenericSelect from "../GenericSelect.vue";

  export default {
    components: {GenericSelect},
    props: {
      value: {
        type: Object,
        required: false,
        default: () => ({})
      },
      typeLivrables: Array,
      phaseExecutions: Array,
      entiteTraitements: Array,
      contacts: Array,
      allPoles: Array,
      allPriorities: Array,
      allStatus: Array
    },
    data() {
      return {
        payload: {
          id : null,
          idPta:{},
          idTypeLivrable : '',
          description: '',
          phaseConcernee: '',
          lot: '',
          priorite: '',
          anneePta: '',
          referentPmo: '',
          pointFocalAsin: '',
          pole: '',
          entiteCharge: '',
          asinLead: '',
          pctRealisation: '',
          statut: '',
          retard: '',
          revuePmo: '',
          datePrevueRevuePmo: '',
          datePrevueRevueDg: ''
        },


      };
    },
    watch: {
      value: {
        immediate: true,
        deep: true,
        async handler(newVal) {
          this.$loading(true);

          try {
            this.payload = { ...this.payload, ...newVal };
          } catch (e) {
            console.error("Erreur dans le watch de value :", e);
          } finally {
            this.$loading(false);
          }
        }
      }
    },

    created() {
      // this.loadData();
    },
    computed: {
      isEditing() {
        return this.payload.id !== null && this.payload.id !== undefined && this.payload.id !== '';
      }
    },
    methods:{
      async handleFormSubmit() {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;
        console.log('Formulaire soumis avec :', this.payload);
        if(!this.isEditing){

          this.$loading(true);
          this.$http.post('/livrables', this.payload)
              .then(({ data }) => {
                if (data) {
                  swal('Information!', 'Enregistrement éffectué avec succès.', 'success');
                   this.$refs.tableRef.loadData();
                  if (this.$refs.observer) {
                    this.$refs.observer.reset();
                  }
                } else {
                  swal('Information!', 'Erreur lors de l\'enregistrement', 'warning');
                }
              })
              .catch((error) => {
                swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
              })
              .finally(() => this.$loading(false));


        }else {

          this.$loading(true);
          this.$http.put('/livrables/' + this.payload.id, this.payload)
              .then(({ data }) => {
                if (data) {
                  swal('Information!', 'Modification éffectuée avec succès.', 'success');
                  // this.$refs.tableRef.loadData();
                  if (this.$refs.observer) {
                    this.$refs.observer.reset();
                  }
                } else {
                  swal('Information!', 'Erreur lors de la modification.', 'warning');
                }
              })
              .catch((error) => {
                swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'warning');
              })
              .finally(() => this.$loading(false));

        }
        this.$emit('cancel');
        this.$emit('refresh');
      },
    }
  };

</script>
